import React, { FunctionComponent } from 'react';

import moment from 'moment';

// Transalte
import { Translate } from 'react-localize-redux';

import Datepicker from '@components/form/datepicker';

import FilterWrapper from './filter-wrapper';

// Controllers
import DropdownCtrl from '@webapp/controllers/form/dropdown';

import { UpdateField } from '@webapp/store/artist-analytics/action-creators';
import { useDispatch } from 'react-redux';

// TODO: DEVTEAM-405 - We need to use the translations here. Currently is not supported by the options of the dropdown.
const DATE_RANGE = [
  {
    value: 'lastWeek',
    label: 'Last week',
    // label: <Translate id="ANALYTICS.MENU.FILTERS.DATE_RANGE.LAST_WEEK" />,
  },
  {
    value: 'lastMonth',
    label: 'Last month',
    // label: <Translate id="ANALYTICS.MENU.FILTERS.DATE_RANGE.LAST_MONTH" />,
  },
  {
    value: 'last3Months',
    label: 'Last 3 months',
    // label: <Translate id="ANALYTICS.MENU.FILTERS.DATE_RANGE.LAST_3_MONTHS" />,
  },
  {
    value: 'lastYear',
    label: 'Last year',
    // label: <Translate id="ANALYTICS.MENU.FILTERS.DATE_RANGE.LAST_YEAR" />,
  },
  {
    value: 'allTime',
    label: 'All time',
    // label: <Translate id="ANALYTICS.MENU.FILTERS.DATE_RANGE.ALL_TIME" />,
  },
  // {
  //   value: 'custom',
  //   label: 'Custom',
  //   // label: <Translate id="ANALYTICS.MENU.FILTERS.DATE_RANGE.CUSTOM" />,
  // },
];

interface DateRangeFilterProps {
  className?: string;
  analyticsRange: string;
  onDateRangeFilterChange: (value: string) => void;
}

const DateRangeFilter: FunctionComponent<DateRangeFilterProps> = ({
  className,
  analyticsRange,
  onDateRangeFilterChange,
}) => {
  const dispatch = useDispatch();
  const [dateRange, setDateRange] = React.useState(analyticsRange);
  const [selectedDate, setSelectedDate] = React.useState<Date>(new Date());
  const [hasDateChange, setHasDateChange] = React.useState(false);

  // TODO: DEVTEAM-405 - Integrate handleDateChange.
  const handleDateChange = (value: Date) => {
    setHasDateChange(true);
    setSelectedDate(value);
    dispatch(new UpdateField('date', value.toISOString()));
  };

  const handleDateRange = (value: string) => {
    setDateRange(value);
    onDateRangeFilterChange(value);
  };

  // TODO: DEVTEAM-405 - We need to use the translations here. Currently is not supported by the options of the dropdown.

  const getMinDate = () => moment('2020-01-01');
  const getMaxDate = () => moment().startOf('day').add(1, 'days');

  return (
    <FilterWrapper
      className={className || ''}
      title={<Translate id="ANALYTICS.MENU.FILTERS.DATE_RANGE" />}
    >
      {dateRange === 'custom' ? (
        <Datepicker
          hasPillShape
          isMonthSelector
          active={moment(selectedDate)}
          onChange={(value) => handleDateChange(new Date(value))}
          max={getMaxDate()}
          min={getMinDate()}
          hasChanges={hasDateChange}
        />
      ) : (
        <DropdownCtrl
          value={dateRange}
          onChange={(value) => handleDateRange(value)}
          options={DATE_RANGE}
          hasPillShape
        />
      )}
    </FilterWrapper>
  );
};

export default DateRangeFilter;
